import axiosInstance from "./client";

export const fetchData = (id) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`/api/content/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          resolve(result.data.data);
        }
      })
      .catch((err) => {
        console.log(err, "fetchData");
        reject(err);
      });
  });
};

export const deleteAccount = (email, password) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .delete(`/api/user/pwa/account?email=${email}&password=${password}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          // console.log(result.data);
          resolve(result.data);
        }
      })
      .catch((err) => {
        // console.log(err.response.data, "deleteAccount");
        reject(err);
      });
  });
};
